export default {"src":"/_next/static/media/quoteTransparent.3df47da9.svg","height":80,"width":100,"blurWidth":0,"blurHeight":0};